//#region IMPORT
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HwpPreview from './HwpPreview';
//#endregion

/**
 * 한글(hwp/hwpx) 파일 미리보기 다이얼로그
 * 새 탭으로 파일을 여는 화면은 한글 원본을 브라우저가 렌더링하지 못하므로 이 다이얼로그를 사용한다.
 * @param {boolean} props.open - 다이얼로그 표시 여부
 * @param {string} props.filePath - 파일 경로 또는 전체 URL
 * @param {string} props.fileName - 파일명 (확장자 포함)
 * @param {Function} props.onClose - 닫기 콜백
 * @returns {JSX.Element} 다이얼로그 컴포넌트
 */
function HwpPreviewDialog({ open, filePath, fileName, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          py: 1.5,
        }}
      >
        <Typography variant="subtitle1" noWrap>
          {fileName || '한글 문서 미리보기'}
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {open && filePath && (
          <HwpPreview filePath={filePath} fileName={fileName} height="75vh" />
        )}
      </DialogContent>
    </Dialog>
  );
}

export default HwpPreviewDialog;
